import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="forms--trix-editor"
export default class extends Controller {
  connect() {
    delete this.element.dataset.directUploadUrl;
    delete this.element.dataset.blobUrlTemplate;
    delete this.element.dataset.directUploadAttachmentName;
    delete this.element.dataset.directUploadToken;
  }

  modifyToolbar() {
    [
      "[data-trix-action='link']",
      "[data-trix-action='increaseNestingLevel']",
      "[data-trix-action='decreaseNestingLevel']",
      "[data-trix-attribute='heading1']",
      "[data-trix-attribute='quote']",
      "[data-trix-attribute='code']",
      "[data-trix-button-group='file-tools']",
    ].forEach((query) => {
      const el = document.querySelector(query);
      el && el.remove();
    });
  }

  disableAcceptance() {
    alert("Drag and Drop is not supported.");
  }
}
